<template>
  <UIDrawer v-model:visible="visible" position="right">
    <template #title>
      <div>
        <div v-if="heading" class="vc-plan-drawer-heading">
          {{ heading }}
        </div>
        <div v-if="subheading" class="vc-plan-drawer-subheading">
          <i18n-t :keypath="subheading">
            <template #termMonths>{{ plan?.termMonths }}</template>
          </i18n-t>
        </div>
      </div>
    </template>

    <PlanDrawerContent v-if="plan" :plan="plan" />
  </UIDrawer>
</template>

<script setup lang="ts">
  import { computed } from "vue"
  import { useOpenedPaymentPlan } from "@versatile-credit-apply/composition"
  import PlanDrawerContent from "@/components/plan/PlanDrawerContent.vue"
  import { useProviderI18n } from "@versatile-credit-apply/sdk"

  defineEmits(["update:visible"])
  const plan = useOpenedPaymentPlan()
  const { te, t } = useProviderI18n(plan.value?.providerKey)

  const heading = computed(() => {
    const headings = [
      `plan.${plan.value?.typeId}.drawer.heading`,
      "plan.drawer.heading",
    ]

    for (const heading of headings) {
      if (te(heading)) {
        return t(heading)
      }
    }

    return undefined
  })

  const subheading = computed(() => {
    const subheadings = [
      `plan.${plan.value?.typeId}.drawer.subheading`,
      "plan.drawer.subheading",
    ]

    for (const subheading of subheadings) {
      if (te(subheading)) {
        return subheading
      }
    }

    return undefined
  })

  const visible = computed({
    get: () => !!plan.value,
    set: (value: boolean) => {
      plan.value = value ? plan.value : null
    },
  })
</script>
